import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const $router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'index',
      meta: {
        title: '航阳商旅网-企业差旅服务,企业差旅月结垫资，差旅服务专注20年！',
        keywords: 'TMC、企业差旅、企业月结垫资、公司差旅管理、公司商旅管理、企业差旅管家、如何节省差旅费、航阳商旅网',
        description: '航阳商旅网成立于2005年，专注为企业提供差旅服务，由单一的企业机票月结发展到综合差旅服务，服务项目包含，企业差旅月结，企业拓展服务，企业员工奖励，等多元化服务,我们的HangYang Tmc差旅管理系统融合航司的NDC以及各大酒店集团CRS,PMS等系统，真正做到了预订即时，准确率高达98%.在直连化进程下差旅成本直降30'
      },
      component: resolve => require(['@/pages/index'], resolve),
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/pages/login/login'], resolve),
    },
    {
      path: '/register',
      name: 'register',
      component: resolve => require(['@/pages/login/register'], resolve),
    },
    {
      path: '/forgetPwd',
      name: 'forgetPwd',
      component: resolve => require(['@/pages/login/forgetPwd'], resolve),
    },
    {
      path: '/parter',
      name: 'parter',
      component: resolve => require(['@/pages/home/parter'], resolve),
    },
    {
      path: '/HotelApply',
      name: 'HotelApply',
      meta: {
        title: '航阳商旅 · 酒店招商｜解锁企业住宿蓝海',
        keywords: '航阳商旅,酒店招商,企业差旅,疗休养,B2B分销',
        description: '入驻航阳商旅，对接头部国央企员工疗休养自由行客源，接入全国百万企业差旅出行住宿需求。'
      },
      component: resolve => require(['@/pages/home/HotelApply'], resolve),
    },
    {
      path: '/course',
      name: 'course',
      meta: {
        title: '航阳商旅网-航阳商旅网的成长历程！',
        keywords: '航阳成长历程、企业差旅垫资，企业会务会议，企业奖励旅游，企业拓展策划执行、航阳商旅网',
        description: '航阳商旅网成立于2005年，专注为企业提供差旅服务，由单一的企业机票月结发展到综合差旅服务，航阳在数十年的成长中，由传统的单一机票差旅模式转型成为多方位综合差旅公司，业务覆盖了海内外住宿，国内国际机票业务代理，会议会展，企业拓展，奖励旅游，企业权益包装与设计的复合型差旅公司.'
      },
      component: resolve => require(['@/pages/home/course'], resolve),
    },
    {
      path: '/meeting',
      name: 'meeting',
      meta: {
        title: '航阳商旅网-企业会务会议执行-活动策划-企业团建奖励旅游-服务百强品质保障！',
        keywords: '会展搭建，会议策划，会议执行，企业团建，企业奖励旅游',
        description: '航阳商旅网成立于2005年，专注为企业提供差旅服务，由单一的企业机票月结发展到综合差旅服务，2014年航阳正式成立航阳展览作为服务企业会务会议,企业权益策划为一体的会展公司,在数十年中先后为国内众多知名百强企业提供员工团建，年度会议，企业奖励旅游等重要项目服务.'
      },
      component: resolve => require(['@/pages/home/meeting'], resolve),
    },
    {
      path: '/about',
      name: 'about',
      meta: {
        title: '航阳商旅网-航阳商旅企业介绍！',
        keywords: '航阳商旅，上海航阳国际旅行社有限公司，航阳会展，航阳展览，航阳旅游',
        description: '航阳商旅网成立于2005年，上海航阳国际旅行社有限公司原为上海航阳旅游咨询有限公司，简称“航阳旅行网”。航阳旅行网成功整合了高科技产业与传统预定相结合，向会员提供集酒店、酒店、机票、会议、签证、租车等全方位旅行服务，被誉为互联网和传统旅游无缝结合的典范.'
      },
      component: resolve => require(['@/pages/home/about'], resolve),
    },
    {
      path: '/journalism',
      name: 'journalism',
      component: resolve => require(['@/pages/home/journalism'], resolve),
    },
    {
      path: '/journalismDetail',
      name: 'journalismDetail',
      component: resolve => require(['@/pages/home/journalismDetail'], resolve),
    },
    {
      path: '/license',
      name: 'license',
      component: resolve => require(['@/pages/home/license'], resolve),
    },
    {
      path: '/joinUs',
      name: 'joinUs',
      component: resolve => require(['@/pages/home/joinUs'], resolve),
    },
    {
      path: '/hornor',
      name: 'hornor',
      component: resolve => require(['@/pages/home/hornor'], resolve),
    },
    {
      path: '/meetingDetail',
      name: 'meetingDetail',
      component: resolve => require(['@/pages/home/meetingDetail'], resolve),
    },
    {
      path: '/FtPolicy',
      name: 'FtPolicy',
      component: resolve => require(['@/pages/company/FtPolicy'], resolve),
    },
    {
      path: '/newCompany',
      name: 'newCompany',
      component: resolve => require(['@/pages/newCompany/index'], resolve),
      children: [{
        path: '/Home',
        name: 'Home',
        component: resolve => require(['@/pages/newCompany/Home'], resolve),
      }, {
        path: '/DownloadCenter',
        name: 'downloadCenter',
        component: resolve => require(['@/pages/newCompany/DownloadCenter'], resolve),
      }, {
        path: '/hyOrder',
        name: 'hyOrder',
        component: resolve => require(['@/pages/newCompany/hyOrder'], resolve),
      }, {
        path: '/OpenMonthPay',
        name: 'openMonthPay',
        component: resolve => require(['@/pages/newCompany/OpenMonthPay'], resolve),
      }, {
        path: '/Protocol',
        name: 'protocol',
        component: resolve => require(['@/pages/newCompany/Protocol'], resolve),
      }, {
        path: '/ServiceContract',
        name: 'serviceContract',
        component: resolve => require(['@/pages/newCompany/ServiceContract'], resolve),
      }, {
        path: '/NoPermissions',
        name: 'noPermissions',
        component: resolve => require(['@/pages/newCompany/NoPermissions'], resolve),
      }, {
        path: '/Help',
        name: 'help',
        component: resolve => require(['@/pages/newCompany/Help'], resolve),
      }, {
        path: '/setting/Pay',
        name: 'pay',
        component: resolve => require(['@/pages/newCompany/setting/Pay'], resolve),
      }, {
        path: '/setting/Cost',
        name: 'cost',
        component: resolve => require(['@/pages/newCompany/setting/Cost'], resolve),
      }, {
        path: '/setting/Invoice',
        name: 'invoice',
        component: resolve => require(['@/pages/newCompany/setting/Invoice'], resolve),
      }, {
        path: '/setting/Bookswithserver',
        name: 'bookswithserver',
        component: resolve => require(['@/pages/newCompany/setting/Bookswithserver'], resolve),
      }, {
        path: '/setting/PrestoreDetail',
        name: 'prestoreDetail',
        component: resolve => require(['@/pages/newCompany/setting/PrestoreDetail'], resolve),
      }, {
        path: '/setting/Recharge',
        name: 'recharge',
        component: resolve => require(['@/pages/newCompany/setting/Recharge'], resolve),
      }, {
        path: '/manage/TravelGeneralSetting',
        name: 'travelGeneralSetting',
        component: resolve => require(['@/pages/newCompany/manage/TravelGeneralSetting'], resolve),
      }, {
        path: '/manage/StandardSplitting',
        name: 'standardSplitting',
        component: resolve => require(['@/pages/newCompany/manage/StandardSplitting'], resolve),
      }, {
        path: '/manage/Addstandard',
        name: 'addstandard',
        component: resolve => require(['@/pages/newCompany/manage/Addstandard'], resolve),
      }, {
        path: '/manage/CityTemplate',
        name: 'cityTemplate',
        component: resolve => require(['@/pages/newCompany/manage/CityTemplate'], resolve),
      }, {
        path: '/manage/Usecar',
        name: 'usecar',
        component: resolve => require(['@/pages/newCompany/manage/Usecar'], resolve),
      }, {
        path: '/manage/Meweditusecar',
        name: 'meweditusecar',
        component: resolve => require(['@/pages/newCompany/manage/Meweditusecar'], resolve),
      }, {
        path: '/manage/Message',
        name: 'message',
        component: resolve => require(['@/pages/newCompany/manage/Message'], resolve),
      }, {
        path: '/manage/ApprovalProcessSettings',
        name: 'approvalProcessSettings',
        component: resolve => require(['@/pages/newCompany/manage/ApprovalProcessSettings'], resolve),
      }, {
        path: '/manage/BasicDataManagement',
        name: 'basicDataManagement',
        component: resolve => require(['@/pages/newCompany/manage/BasicDataManagement'], resolve),
      }, {
        path: '/employees/EmployeeAndDept',
        name: 'employeeAndDept',
        component: resolve => require(['@/pages/newCompany/employees/EmployeeAndDept'], resolve),
      }, {
        path: '/employees/Role',
        name: 'role',
        component: resolve => require(['@/pages/newCompany/employees/Role'], resolve),
      }, {
        path: '/employees/External',
        name: 'external',
        component: resolve => require(['@/pages/newCompany/employees/External'], resolve),
      }, {
        path: '/employees/ResponsiblePartyControl',
        name: 'responsiblePartyControl',
        component: resolve => require(['@/pages/newCompany/employees/ResponsiblePartyControl'], resolve),
      }, {
        path: '/checkAccount/CheckAccountIndex',
        name: 'checkAccountIndex',
        component: resolve => require(['@/pages/newCompany/checkAccount/CheckAccountIndex'], resolve),
      }, {
        path: '/checkAccount/Flight',
        name: 'flight',
        component: resolve => require(['@/pages/newCompany/checkAccount/Flight'], resolve),
      }, {
        path: '/checkAccount/IeFlight',
        name: 'ieFlight',
        component: resolve => require(['@/pages/newCompany/checkAccount/IeFlight'], resolve),
      }, {
        path: '/checkAccount/Hotel',
        name: 'hotel',
        component: resolve => require(['@/pages/newCompany/checkAccount/Hotel'], resolve),
      }, {
        path: '/checkAccount/IeHotel',
        name: 'iehotel',
        component: resolve => require(['@/pages/newCompany/checkAccount/IeHotel'], resolve),
      }, {
        path: '/checkAccount/Train',
        name: 'train',
        component: resolve => require(['@/pages/newCompany/checkAccount/Train'], resolve),
      }, {
        path: '/checkAccount/Car',
        name: 'car',
        component: resolve => require(['@/pages/newCompany/checkAccount/Car'], resolve),
      }, {
        path: '/checkAccount/Vacation',
        name: 'vacation',
        component: resolve => require(['@/pages/newCompany/checkAccount/Vacation'], resolve),
      }, {
        path: '/checkAccount/Vas',
        name: 'vas',
        component: resolve => require(['@/pages/newCompany/checkAccount/Vas'], resolve),
      }, {
        path: '/checkAccount/PaymentDays',
        name: 'paymentDays',
        component: resolve => require(['@/pages/newCompany/checkAccount/PaymentDays'], resolve),
      }, {
        path: '/report/OrderReport',
        name: 'orderReport',
        component: resolve => require(['@/pages/newCompany/report/OrderReport'], resolve),
      }, {
        path: '/report/TripApplyReport',
        name: 'tripApplyReport',
        component: resolve => require(['@/pages/newCompany/report/TripApplyReport'], resolve),
      }, {
        path: '/report/TripIncityCarApplyReport',
        name: 'tripIncityCarApplyReport',
        component: resolve => require(['@/pages/newCompany/report/TripIncityCarApplyReport'], resolve),
      }, {
        path: '/report/TripOverApplyReport',
        name: 'tripOverApplyReport',
        component: resolve => require(['@/pages/newCompany/report/TripOverApplyReport'], resolve),
      }, {
        path: '/report/Flightopenticket',
        name: 'flightopenticket',
        component: resolve => require(['@/pages/newCompany/report/Flightopenticket'], resolve),
      }, {
        path: '/bills/Apply',
        name: 'apply',
        component: resolve => require(['@/pages/newCompany/bills/Apply'], resolve),
      }, {
        path: '/bills/Search',
        name: 'search',
        component: resolve => require(['@/pages/newCompany/bills/Search'], resolve),
      }, {
        path: '/bills/Insurance',
        name: 'insurance',
        component: resolve => require(['@/pages/newCompany/bills/Insurance'], resolve),
      }, {
        path: '/agreementPrice/AgreementPriceFlight',
        name: 'agreementPriceFlight',
        component: resolve => require(['@/pages/newCompany/agreementPrice/AgreementPriceFlight'], resolve),
      }, {
        path: '/agreementPrice/FlightEdit',
        name: 'flightEdit',
        component: resolve => require(['@/pages/newCompany/agreementPrice/FlightEdit'], resolve),
      }, {
        path: '/agreementPrice/WhiteListRecord',
        name: 'whiteListRecord',
        component: resolve => require(['@/pages/newCompany/agreementPrice/WhiteListRecord'], resolve),
      }, {
        path: '/agreementPrice/CheckFailWhiteListRecord',
        name: 'checkFailWhiteListRecord',
        component: resolve => require(['@/pages/newCompany/agreementPrice/CheckFailWhiteListRecord'],
          resolve),
      }, {
        path: '/manageCorpInfo/PersonnelAuthority',
        name: 'personnelAuthority',
        component: resolve => require(['@/pages/newCompany/manageCorpInfo/PersonnelAuthority'], resolve),
      }, {
        path: '/manageCorpInfo/Certification',
        name: 'certification',
        component: resolve => require(['@/pages/newCompany/manageCorpInfo/Certification'], resolve),
      }, {
        path: '/data/dateAll',
        name: 'dateAll',
        component: resolve => require(['@/pages/newCompany/data/dateAll'], resolve),
      }, {
        path: '/reimbursement/ReimbursementIndex',
        name: 'reimbursementIndex',
        component: resolve => require(['@/pages/newCompany/reimbursement/ReimbursementIndex'], resolve),
      }, {
        path: '/reimbursement/CreatReimbursement',
        name: 'creatReimbursement',
        component: resolve => require(['@/pages/newCompany/reimbursement/CreatReimbursement'], resolve),
      }, {
        path: '/reimbursement/Financial',
        name: 'financial',
        component: resolve => require(['@/pages/newCompany/reimbursement/Financial'], resolve),
      }]
    },
  ]
})

$router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    location.reload();
  }
});

$router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '航阳商旅网' // 根据路由元信息设置标题
  if (to.meta.keywords) {
    let keyword = '',
      desc = '';
    if (typeof to.meta.keywords === 'string') {
      keyword = to.meta.keywords;
    }
    if (typeof to.meta.description === 'string') {
      desc = to.meta.description;
    }

    const head = document.getElementsByTagName('head')[0];

    const keywordsMeta = document.createElement('meta');
    keywordsMeta.setAttribute('name', 'keywords');
    keywordsMeta.setAttribute('content', keyword);
    head.appendChild(keywordsMeta);

    const descriptionMeta = document.createElement('meta');
    descriptionMeta.setAttribute('name', 'description');
    descriptionMeta.setAttribute('content', desc);
    head.appendChild(descriptionMeta);
  }
  next()
})

export default $router;



// WEBPACK FOOTER //
// ./src/router/index.js